import { GlobalAppState } from '@state/store';

export const getShareLink = (state: GlobalAppState) => state.app.shareLink;
